import { DropdownPopoverOptions } from 'modules/common/components/ToolbarPopover/DropdownPopover';
import { ReactNode, createContext, useContext } from 'react';
import { CustomFontState } from 'types/customFont.types';

export type BrandNamesType = DropdownPopoverOptions;

const initalContext = {
  documentFonts: [],
  brandFonts: [],
  showBrandSection: false,
  addDocumentFont: (font: string) => {},
};

interface DocumentFontContextI {
  documentFonts: string[];
  // a list of unique font families from the brand kit
  brandFonts: string[];
  brandOptions?: ReactNode;
  customFontsMap?: Map<string, CustomFontState>;
  showBrandSection: boolean;
  addDocumentFont: (font: string) => void;
}

interface DocumentFontProviderProps extends DocumentFontContextI {
  children: ReactNode;
}

const DocumentFontContext = createContext<DocumentFontContextI>(initalContext);

export const DocumentFontProvider = ({
  children,
  brandFonts,
  brandOptions,
  customFontsMap,
  documentFonts,
  showBrandSection,
  addDocumentFont,
}: DocumentFontProviderProps) => {
  return (
    <DocumentFontContext.Provider
      value={{
        brandFonts,
        brandOptions,
        customFontsMap,
        documentFonts,
        showBrandSection,
        addDocumentFont,
      }}
    >
      {children}
    </DocumentFontContext.Provider>
  );
};

export const useDocumentFonts = () => {
  const documentFonts = useContext(DocumentFontContext);
  return documentFonts;
};
